import React, { useState, useEffect } from 'react';
import {
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction,
  Paper,
  Box
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Home as HomeIcon,
  Favorite as FavoriteIcon,
  LocationOn as LocationIcon,
  Restore as RestoreIcon
} from '@mui/icons-material';
import { colorPrimary } from '../../Styles/Colors';

const BottomNavigation = ({
  variant = 'default', // default, paper, fixed
  position = 'relative', // relative, fixed, sticky
  showLabels = true,
  actions = [
    { label: 'Home', icon: <HomeIcon />, path: '/' },
    { label: 'Favorites', icon: <FavoriteIcon />, path: '/favorites' },
    { label: 'Nearby', icon: <LocationIcon />, path: '/nearby' },
    { label: 'Recents', icon: <RestoreIcon />, path: '/recents' }
  ],
  sx = {},
  onNavigate, // Optional callback when navigation happens
  ...props
}) => {
  const location = useLocation();
  const [value, setValue] = useState(0);

 
  useEffect(() => {
    const currentIndex = actions.findIndex(action => action.path === location.pathname);
    if (currentIndex !== -1) {
      setValue(currentIndex);
    }
  }, [location.pathname, actions]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const bottomNavComponent = (
    <MuiBottomNavigation
      value={value}
      onChange={handleChange}
      showLabels={showLabels}
      sx={{
        width: '100%',
        '& .MuiBottomNavigationAction-root': {
          color: '#9e9e9e',
          '&.Mui-selected': {
            color: colorPrimary
          }
        },
        ...sx
      }}
      {...props}
    >
      {actions.map((action, index) => (
        <BottomNavigationAction
          key={action.path || index}
          label={action.label}
          icon={action.icon}
          component={NavLink}
          to={action.path || "#"}
          onClick={() => {
            if (onNavigate) {
              onNavigate(action.path, action);
            }
            if (action.onClick) {
              action.onClick(action.path, action);
            }
          }}
          sx={{
            textDecoration: 'none',
            '&.active': {
              color: '#1976d2'
            },
         
            ...action.sx
          }}
        />
      ))}
    </MuiBottomNavigation>
  );

  if (variant === 'paper') {
    return (
      <Paper 
        sx={{ 
          position: position,
          bottom: position === 'fixed' ? 0 : 'auto',
          left: position === 'fixed' ? 0 : 'auto',
          right: position === 'fixed' ? 0 : 'auto',
          zIndex: position === 'fixed' ? 1000 : 'auto',
          elevation: 3
        }} 
        elevation={3}
      >
        {bottomNavComponent}
      </Paper>
    );
  }

  if (variant === 'fixed') {
    return (
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          bgcolor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider'
        }}
      >
        {bottomNavComponent}
      </Box>
    );
  }

  return bottomNavComponent;
};

export default BottomNavigation;
